/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";

import MODAL_VIEW_TYPES from "../../../constants/modalViewTypes";
import { contactListingAgent } from "../contactFormSlice";

const initialState = {
  isAgentContactDrawerOpen: false,
  modalViewType: MODAL_VIEW_TYPES.agentContact
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openAgentContactDrawer(state) {
      state.isAgentContactDrawerOpen = true;
    },
    closeAgentContactDrawer(state) {
      state.isAgentContactDrawerOpen = false;
    },
    setModalViewType(state, { payload }) {
      state.modalViewType = payload;
    }
  },
  extraReducers: {
    [contactListingAgent.rejected]: state => {
      state.modalViewType = MODAL_VIEW_TYPES.error;
    },
    [contactListingAgent.fulfilled]: (state, action) => {
      const formErrorsPresent = Boolean(
        action.payload?.data?.contact_sale_listing_agent?.errors
      );

      if (formErrorsPresent) {
        state.modalViewType = MODAL_VIEW_TYPES.agentContact;
      } else {
        state.modalViewType = MODAL_VIEW_TYPES.success;
      }
    }
  }
});

export const {
  closeAgentContactDrawer,
  openAgentContactDrawer,
  setModalViewType
} = uiSlice.actions;

export default uiSlice.reducer;
